import { c as _c } from "react/compiler-runtime";
import { useGetBulkDialogContent } from "@components/common/faro-table/bulk-dialog/bulk-dialog-helper";
import { FaroCoreApiUtils } from "@stellar/core-api-client";
import { useAppSelector } from "@store/store-helper";
import { bulkActionResultsSelector, numberOfUpdatingItemsSelector } from "@store/table/table-selector";
import { nounPluralize } from "@utils/data-display";
import { getPrettyName } from "@utils/user-utils";

/** Determines the content of bulk dialog and success dialog for removing a member/team from projects */
export function useRemoveFromProjectsBulkDialogContent(member) {
  const $ = _c(22);
  let t0;
  if ($[0] !== member) {
    t0 = getPrettyName(member);
    $[0] = member;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const memberDisplayName = t0;
  const numberOfUpdatingItems = useAppSelector(numberOfUpdatingItemsSelector);
  const {
    numberOfSuccess,
    numberOfErrors
  } = useAppSelector(bulkActionResultsSelector);
  const isIndividualMember = "kind" in member && !FaroCoreApiUtils.Member.isTeam(member);
  const subjectLabel = isIndividualMember ? "member" : "team";
  let t1;
  if ($[2] !== numberOfUpdatingItems) {
    t1 = nounPluralize({
      counter: numberOfUpdatingItems,
      word: "project",
      shouldShowCounter: false
    });
    $[2] = numberOfUpdatingItems;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const pluralizedProject = t1;
  const t2 = `Remove member from the ${pluralizedProject}?`;
  const t3 = `When you confirm this action, the ${subjectLabel} ` + `${memberDisplayName} will no longer be able to access the following ${pluralizedProject}.`;
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = {
      title: t2,
      description: t3
    };
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = `Couldn't remove ${numberOfErrors} of ${numberOfUpdatingItems} ${pluralizedProject}`;
  let t6;
  if ($[7] !== t5) {
    t6 = {
      title: t5,
      description: "These projects couldn't be removed, check the details and try again."
    };
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4 || $[10] !== t6) {
    t7 = {
      initial: t4,
      failed: t6,
      confirmButtonText: "remove",
      entityType: "project"
    };
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const bulkDialogContent = useGetBulkDialogContent(t7);
  let t8;
  if ($[12] !== numberOfSuccess) {
    t8 = nounPluralize({
      counter: numberOfSuccess,
      word: "project",
      shouldShowCounter: false
    });
    $[12] = numberOfSuccess;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const pluralizedSuccessProject = t8;
  let t9;
  if ($[14] !== numberOfSuccess) {
    t9 = nounPluralize({
      counter: numberOfSuccess,
      word: "project"
    });
    $[14] = numberOfSuccess;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = `${t9} removed`;
  const t11 = `The ${subjectLabel} ${memberDisplayName} has been removed from the selected ${pluralizedSuccessProject}.`;
  let t12;
  if ($[16] !== t10 || $[17] !== t11) {
    t12 = {
      title: t10,
      description: t11
    };
    $[16] = t10;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  const successDialogContent = t12;
  let t13;
  if ($[19] !== bulkDialogContent || $[20] !== successDialogContent) {
    t13 = {
      bulkDialogContent,
      successDialogContent
    };
    $[19] = bulkDialogContent;
    $[20] = successDialogContent;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  return t13;
}